import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import uploadReducer from "./uploadSlice";
import analysisReducer from "./analysisSlice";
import authReducer from "./auth";
import trustReducer from "./trusts";
import filtersReducer from "./filters";
import productivityReducer from "./productivity";
import performanceReducer from "./performance";
import priceFormatReducer from "./priceFormat";
import agencyReducer from "./agencySlice";
import dashboardReducer from "./dashboardSlice";
import portfolioReducer from "./portfolioSlice";
import permissionReducer from "./permissionSlice";
import allocationReducer from "./allocationSlice";
import userRolesReducer from "./userRoleSlice";
import collecteazeAiReducer from './collecteazeAiSlice';
import bucketwiseReducer from './bucketSlice';
import casesInfoReducer from './casesInfoSlice';
import telecallerDashboardReducer from './telecaller/telecallerDashboard';
import casesReducer from './telecaller/cases';
import telecallerBankDashboardReducer from './telecaller/bankDashboard';
import telecallerSummaryReducer from './telecaller/telecallerSummary';

const appReducer = combineReducers({
  upload: uploadReducer,
  analysis: analysisReducer,
  auth: authReducer,
  trust: trustReducer,
  filters: filtersReducer,
  productivity: productivityReducer,
  performance: performanceReducer,
  priceFormat: priceFormatReducer,
  agency: agencyReducer,
  dashboard: dashboardReducer,
  portfolio: portfolioReducer,
  permission: permissionReducer,
  allocation: allocationReducer,
  userRoles: userRolesReducer,
  collecteazeAi: collecteazeAiReducer,
  bucketwise: bucketwiseReducer,
  casesInformation: casesInfoReducer,
  
  // telecaller 
  telecallerDashboard: telecallerDashboardReducer,
  telecallerCases: casesReducer,
  telecallerBankDashboard: telecallerBankDashboardReducer,
  telecallerSummary:telecallerSummaryReducer

});

const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    storage.removeItem("persist:root");
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
